export enum OrderType {
  CustomerReturn = 'R',
  CustomerReturnNupcoStock = 'RN',
  NupcoSalesReturns = 'ZN04',
  CustomerOutboundOrders = 'C',
  DistributionOutboundOrder = 'D',
  TransferOrders = 'T',
  VendorSupplierReturns = 'V',
  SalesOrder = 'S',
  NupcoRoyalCourt = 'ZN05',
  NupcoDonationIssue = 'ZN02',
  StoTransfer = 'Z122',
  ScrapOrders = 'SCR',
  PrepareOrder = 'ZNCG',
  StockToCustomerStock = 'ZNNC',
  SalesWithPrice = 'ZN01',
  ZPG1 = 'ZPG1',
  MOIR = 'MOI-R', 
}
